import { withHandlers } from 'recompose'
import DropdownOption from './DropdownOption'
import { noop } from 'helpers/utils'

export default withHandlers({
  handleSelect: ({ onSelect = noop, value }) => () => onSelect(value)
})(DropdownOption)
